module.exports = __webpack_public_path__ + "img/bg2.cacf61f4.png";